// authApi.js
import { API_CONFIG} from "../../../utils/api-config";
import fetchWithAuth from "../../../utils/apiAthurization";

export const StoreCategoryMedicalStore = async (data) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/medical-store/categories-medical-store`,'POST',data
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const GetCategoriesMedicalStore = async () => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/medical-store/categories-medical-store`
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "Categories fetching failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const GetCategoryMedicalStoreById = async (id) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/medical-store/categories-medical-store/${id}`
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const UpdateCategoryMedicalStore = async (id,data) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/medical-store/categories-medical-store/${id}`,'PATCH',data
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const DeleteCategoryMedicalStore = async (id) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/medical-store/categories-medical-store/${id}`,'DELETE'
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};